import React, { Component } from "react";
import PropTypes from "prop-types";
import { CSSTransitionGroup } from 'react-transition-group';
import VideoTemplatesCategorySelect from "./VideoTemplatesCategorySelect";
import VideoRecord from "./VideoRecord";
import VideoPlayback from "./VideoPlayback";
import { toastr } from "react-redux-toastr";
import { connect } from "react-redux";
import * as Constants from '../constants';
import { Link } from "react-router-dom";
import { Modal, ProgressBar } from "react-bootstrap";
import VideoTemplatesList from "./VideoTemplatesList";

import S3 from 'aws-sdk/clients/s3';
import { getS3FilebrowserDirectory, getS3Tokens, fetchVideoTemplateByName } from "../actions/index";

class VideoTemplatesForm extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    video_template_category_id: PropTypes.number.isRequired,
    categories: PropTypes.array
  };

  constructor(props) {
    super(props);
    this.check_thumbnail_exists = this.check_thumbnail_exists.bind(this);

    // Safari 3.0+ "[object HTMLElementConstructor]" 
    let recordOrUpload = 'record';
    /* eslint-disable no-undef */
    const isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));
    /* eslint-enable no-undef */
    if(isSafari){
      recordOrUpload = 'upload';
    }

    // Default to upload if ?mode=upload IE. When we come here from LM Upload button
    if (this.props.location) {
      let searchParams = new URLSearchParams(this.props.location.search);
      if(searchParams.get("mode") == 'upload'){
        recordOrUpload = 'upload';
      }
    }

    this.state = {
      name:                       this.props.name,
      mode:                       this.props.mode,
      video_template_category_id: this.props.video_template_category_id,
      categories:                 this.props.categories,
      s3_url:                     this.props.s3_url,
      old_s3_url:                 this.props.s3_url,
      errors:                     {},
      accessKeyId:                null,
      secretAccessKey:            null,
      sessionToken:               null,
      fileBlob:                   null,
      duration:                   null,
      showModal:                  false,
      selectedFileName:           null,
      recordOrUpload:             recordOrUpload,
      recording:                  false,
      preparing:                  false,
      uploadProgress:             0,
      isSafari:                   isSafari,
      safariErrorShown:           false
    };
  }

  closeModal() {
    this.setState({ showModal: false });
  }

  openModal() {
    this.setState({ showModal: true });
  }

  handleChangeName(e) {
    let errors = this.state.errors;
    delete errors['name'];
    this.setState({ name: e.target.value, errors: errors });
  }

  handleSelectCategory(video_template_category_id) {
    let errors = this.state.errors;
    delete errors['category_id'];
    this.setState({ video_template_category_id: video_template_category_id, errors: errors });
  }

  handleFinishRecord(data) {
    this.setState({ fileBlob: data });
  }

  handleFinishSync(s3_url) {
    this.setState({ s3_url: s3_url.replace("_raw","") }, function () {
      if (Object.keys(this.state.errors).length == 0) {
          this.props.handleSubmit(this.state);
          this.closeModal();
        }
    });
  }

  onDeleteClickConfirmation() {
    const msg =
      "Are you sure you want to delete this video? Any existing email/sms templates or sent emails/sms using this video will have a broken image and link. You cannot undo deletion.";
    const toastrConfirmOptions = {
      onOk: () => this.props.handleDelete()
    };
    toastr.confirm(msg, toastrConfirmOptions);
  }

  safariConfirmation() {
    const msg = "Safari is currently not supported for recording video. Please use Chrome or Firefox."
    const toastrConfirmOptions = { };
    toastr.confirm(msg, toastrConfirmOptions);
    this.setState({ safariErrorshown: true });
  }

  onFileChange(e) {
    let errors = this.state.errors;
    delete errors['selectedFileName'];
    this.setState({ fileBlob: event.target.files[0], selectedFileName: event.target.files[0].name, errors: errors });
  }

  syncToS3(callbackFunction) {
    this.props.getS3FilebrowserDirectory()
      .then(response => {
        if (response.payload.status == 200) {
          let s3_browser_directory = response.payload.data.directory;
          let creds_url =
              process.env.API_ROOT_URL +
              "/s3_browser/access_token?X-Site-UUID=" +
              localStorage.getItem('lastSiteUUID') +
              "&directory=" +
              s3_browser_directory
          this.setState({ s3_browser_directory: s3_browser_directory });
          this.props
            .getS3Tokens(creds_url)
            .then(response => {
              if (response.payload.status == 200) {
                this.setState({ s3_status: "show", });

                // TODO: Make this another method
                let accessKeyId = response.payload.data.AccessKeyId;
                let secretAccessKey = response.payload.data.SecretAccessKey;
                let sessionToken = response.payload.data.SessionToken;
                let config = {
                  apiVersion: '2006-03-01',
                  region: 'us-east-1',
                  accessKeyId: accessKeyId,
                  secretAccessKey: secretAccessKey,
                  sessionToken: sessionToken,
                  correctClockSkew: true,
                  params: {},
                }

                let fileName = this.uuidv4();

                if (this.state.old_s3_url != null) {
                  const pathArr = this.state.old_s3_url.split('/');
                  fileName = pathArr[pathArr.length - 1].split(".").slice(0, -1).join(".");
                }

                if ( this.state.fileBlob != null ) {
                  this.syncVideoToS3(config, fileName, callbackFunction);
                } else {
                  callbackFunction(this.props.old_s3_url);
                }

              }
            });
          }
      });

  }

  syncVideoToS3(config, fileName, callbackFunction) {
    config.params.Bucket = 'am1-rg-spoder-raws';
    let client = new S3( config );
    const fileExt = this.state.fileBlob.name.split('.').pop().toLowerCase();
    const path = this.state.s3_browser_directory + "/videos/" + fileName + "_raw." + fileExt;
    const d = {
          Body: this.state.fileBlob,
          Key: path,
          ContentType: this.state.fileBlob.type,
        };
    const self = this;
    client.upload(d, function(err, data) {
      let raw_url = data.Location;
      let thumbnail_url = raw_url.replace("am1-rg-spoder-raws.s3.amazonaws.com","s3.amazonaws.com/u.realgeeks.media").replace("videos/","videos/RG-Recordings/").replace("_raw","").split(".").reverse().slice(1).reverse().join(".") + ".gif"
      self.wait_on_thumbnail( thumbnail_url, raw_url, callbackFunction );
    }).on('httpUploadProgress', function(e) {
      let progressPercentage = parseInt((e.loaded * 100) / e.total);
      self.setState({ uploadProgress: progressPercentage})
    });
  }

  wait_on_thumbnail( thumbnail_url, raw_url, callbackFunction ) {
    this.setState({ preparing: true });
    this.check_thumbnail_exists(thumbnail_url, raw_url, callbackFunction);
  }

  check_thumbnail_exists( thumbnail_url, raw_url, callbackFunction ) {
    setTimeout(() => {
      const self = this;
      jQuery.ajax({
        type:     "get",
        url:      thumbnail_url,
        error: function (request, error) {
          self.check_thumbnail_exists(thumbnail_url, raw_url, callbackFunction);
        },
        success: function () {
          self.setState({ preparing: false });
          callbackFunction(raw_url);
        }
      });
    }, 1000);
  }

  async validate() {
    let errors = {};
    if (this.state.name == "" || this.state.name === undefined) {
      errors = Object.assign(errors, {name: 'The name may not be blank.'});
    }
    let nameExists = await this.videoNameExists();
    if ( nameExists == true ) {
      errors = Object.assign(errors, {name: 'There is already a video with this name. Please use a different name.'});
    }
    if (this.state.recordOrUpload == 'record') {
      if (this.state.recording == true) {
        errors = Object.assign(errors, { fileBlob: 'It looks like you are still recording. Click the square stop above.'});
      } else if (this.state.mode == 'new' && this.state.fileBlob === null) {
        errors = Object.assign(errors, { fileBlob: 'You must first record a video.'});
      }
    } else if (this.state.recordOrUpload == 'upload') {
      if (this.state.selectedFileName === null) {
        errors = Object.assign(errors, { selectedFileName: 'You must first select a video file to upload.'});
      } else if (this.state.fileBlob.size > 1024 * 1048576 ) {
        // 300 mb is the current limit
        errors = Object.assign(errors, { selectedFileName: 'The file you have chosen to upload is over the current limit of 1 gb. Please choose a smaller file.'});
      } else {
        const selectedFileExtension = this.state.selectedFileName.split('.').pop().toLowerCase();
        const supportedTypes = [ 'webm', 'mp4', 'mpg', 'mov', 'avi', 'flv', 'mpg', 'wmv', 'm4v', 'mkv', 'x-matroska' ];
        if (!supportedTypes.includes(selectedFileExtension)) {
          errors = Object.assign(errors, { selectedFileName: 'The selected video file is not a supported video type. Please use one of the following video types: ' + supportedTypes});
        }
      }
    }
    this.setState({ errors: errors });
    if (Object.keys(errors).length > 0) {
      toastr.error("Please correct the errors below before saving.");
      return false
    } else {
      return true
    }
  }

  async videoNameExists() {
    let res = await this.props.fetchVideoTemplateByName(this.state.name)
      .then(response => {
      if (response.payload.status == 200) {
        this.closeModal();
        return true;
      } else {
        return false;
      }
    });
    return res;
  }

  uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
  }

  getDuration() {
    var vid = document.createElement('video');
    var fileURL = URL.createObjectURL(this.state.fileBlob);
    vid.src = fileURL;
    const self = this;
    vid.onloadedmetadata = function() {
      // Workaround for Chrome bug: https://stackoverflow.com/questions/38443084/how-can-i-add-predefined-length-to-audio-recorded-from-mediarecorder-in-chrome/39971175#39971175
      if (this.duration === Infinity) {
        this.currentTime = 1e101;
        this.ontimeupdate = function() {
          this.ontimeupdate = () => {
            return;
          }
          self.setState({ duration: this.duration });
        }
      } else {
        self.setState({ duration: this.duration });
      }
    };
  }

  async save(e) {
    e.preventDefault();
    const valid = await this.validate();
    if (valid == true) {
      if (this.state.mode == 'new') {
        this.openModal();
        this.getDuration();
        this.syncToS3(this.handleFinishSync.bind(this));
      } if (this.state.mode == 'edit') {
        this.props.handleSubmit(this.state);
      }
    }
  }

  handleToggleRecording(recordingState) {
    let errors = this.state.errors;
    delete errors['fileBlob'];
    this.setState({ recording: recordingState, errors: errors });
  }

  recOrPlayVideo() {
    if (this.state.mode == 'new') {
      return (
        <VideoRecord
          handleFinishRecord={this.handleFinishRecord.bind(this)}
          handleToggleRecording={this.handleToggleRecording.bind(this)}
          isSafari={this.state.isSafari}
        />
      )
    } else {
      return (
        <VideoPlayback s3_url={this.state.s3_url} conversion_complete={this.props.conversion_complete} match={this.props.match} />
      )
    }

  }

  toggleRecOrUpload(mode, e) {
    let errors = this.state.errors;
    delete errors['selectedFileName'];
    delete errors['fileBlob'];
    if (this.state.recordOrUpload != mode) {
      this.setState({ recordOrUpload: mode, errors: errors });
    }
  }

  maybeHandleInsertVideoLink(s3_url) {
    if (this.props.handleInsertVideoLink) {
      this.props.handleInsertVideoLink(s3_url)
    }
  }

  render() {
    let { id, name, handleSubmit } = this.props;
    if (!name && id) {
      return (
        <CSSTransitionGroup
          transitionName="spinner"
          transitionAppear={true}
          transitionAppearTimeout={500}
        >
          <div id="content" className="spinner-content">
            <div className="vertical-center">
              <i className="fa fa-refresh fa-4x fa-spin" />
            </div>
          </div>
        </CSSTransitionGroup>
      );
    }
    if (this.state.recordOrUpload == 'record' && this.state.isSafari && !this.state.safariErrorshown ) {
      this.safariConfirmation();
    }
    return (
      <form className='video_template_form clearfix'>

        <div
          className={`form-group ${
            this.state.errors.category_id ? "has-error" : ""
          }`}
        >
          <ul className="nav nav-tabs">
            <li role="presentation"
              className={`form-group ${
                this.state.recordOrUpload == 'record' ? "active" : ""
              }`}
              >
                <a onClick={this.toggleRecOrUpload.bind(this, 'record')}>Record Video</a>
            </li>
            <li role="presentation"
              className={`form-group ${
                this.state.recordOrUpload == 'upload' ? "active" : ""
              }`}
              >
              <a onClick={this.toggleRecOrUpload.bind(this, 'upload')}>Upload Video</a>
            </li>
            <li role="presentation"
              className={`form-group
                ${ this.props.inline == "true" ? "show" : "hide" }
                ${ this.state.recordOrUpload == 'select' ? "active" : "" }
              `}
              >
              <a onClick={this.toggleRecOrUpload.bind(this, 'select')}>Select Video</a>
            </li>
          </ul>

          <div className={`m-b-40
            ${ this.state.recordOrUpload == 'record' ? "show" : "hide" }
            ${ this.state.errors.fileBlob ? "has-error" : "" }
            `} >
        <div className='video_template_fields'>
          <div
            className={`form-group ${this.state.errors.name ? "has-error" : ""}`}
          >
            <label>Name</label>
            <input
              type="text"
              className="form-control name_field"
              onChange={this.handleChangeName.bind(this)}
              value={this.state.name}
            />
            <div className="help-block">{this.state.errors.name}</div>
          </div>

          <div
            className={`form-group ${
              this.state.errors.category_id ? "has-error" : ""
            }`}
          >
            <label>Category (optional)</label>
            <VideoTemplatesCategorySelect
              match={this.props.match}
              handleSelectCategory={this.handleSelectCategory.bind(this)}
              categories={this.state.categories}
              video_template_category_id={this.state.video_template_category_id}
            />
            <div className="help-block">{this.state.errors.category_id}</div>
          </div>
        </div>
            { this.recOrPlayVideo() }
            <div className="help-block">{this.state.errors.fileBlob}</div>
          </div>

          <div className={`
            ${ this.state.recordOrUpload == 'upload' ? "show" : "hide" }
            ${ this.state.errors.selectedFileName ? "has-error" : "" }
            `} >
            <div className="panel panel-default">
              <div className="panel-body">
        <div className='video_template_fields'>
          <div
            className={`form-group ${this.state.errors.name ? "has-error" : ""}`}
          >
            <label>Name</label>
            <input
              type="text"
              className="form-control name_field"
              onChange={this.handleChangeName.bind(this)}
              value={this.state.name}
            />
            <div className="help-block">{this.state.errors.name}</div>
          </div>

          <div
            className={`form-group ${
              this.state.errors.category_id ? "has-error" : ""
            }`}
          >
            <label>Category (optional)</label>
            <VideoTemplatesCategorySelect
              match={this.props.match}
              handleSelectCategory={this.handleSelectCategory.bind(this)}
              categories={this.state.categories}
              video_template_category_id={this.state.video_template_category_id}
            />
            <div className="help-block">{this.state.errors.category_id}</div>
          </div>
        </div>

                <div className="input-group">
                    <label className="input-group-btn">
                        <span className="btn btn-primary">
                            Browse&hellip; <input type="file" style={{ display: "none" }} onChange={this.onFileChange.bind(this)} />
                        </span>
                    </label>
                    <input type="text" className="form-control" readonly
                      value={this.state.selectedFileName}
                    />
                </div>
              </div>
            </div>
            <div className="help-block">{this.state.errors.selectedFileName}</div>
          </div>

        </div>

          <div className={`
            ${ this.state.recordOrUpload == 'select' ? "show" : "hide" }
            ${ this.state.errors.selectedFileName ? "has-error" : "" }
            `} >
            <div className="panel panel-default">
              <div className="panel-body">
                <VideoTemplatesList
                  match={this.props.match}
                  handleSubmit={this.props.handleSubmit.bind(this)}
                  handleInsertVideoLink={this.maybeHandleInsertVideoLink.bind(this)}
                />
              </div>
            </div>
          </div>

        <Link
          to={`/video_templates?${Constants.DEFAULT_PAGINATION}`}
          className={`btn btn-default pull-left m-r-10
            ${ this.props.inline == 'true' ? "hide" : "show" }
            `} >
          Back
        </Link>
        <Link
          className={`btn btn-danger pull-left delete_template_btn m-r-10 ${this.state.mode == 'edit' ? '': 'hide'}`}
          onClick={this.onDeleteClickConfirmation.bind(this)}
        >
          Delete Video
        </Link>


        <button onClick={this.save.bind(this)}
          className={`btn pull-right btn-primary ${this.state.recordOrUpload == 'select' ? 'hide': 'show'}`}
        >
          Save
        </button>
        <Modal
          show={this.state.showModal}
          onHide={this.closeModal.bind(this)}
          backdrop="static"
          keyboard={false}
          autoFocus={true}
          enforceFocus={true}
        >
          <Modal.Header closeButton={true}>
            <Modal.Title id="contained-modal-title-lg">
              { this.state.preparing == true ? "Preparing . . ." : "Uploading . . ." }
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className={`vertical-center
              ${ this.state.preparing == false ? "show" : "hide" }
            `} >
              <ProgressBar active now={this.state.uploadProgress} label={`${this.state.uploadProgress}%`} style={{ width: '100%' }}/>
            </div>
            <div className={`vertical-center
              ${ this.state.preparing == true ? "show" : "hide" }
            `} >
              <CSSTransitionGroup
                transitionName="spinner"
                transitionAppear={true}
                transitionAppearTimeout={500}
              >
                <div className="text-center">
                  <i className="fa fa-refresh fa-4x fa-spin" />
                </div>
              </CSSTransitionGroup>
            </div>
          </Modal.Body>
        </Modal>
      </form>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

export default connect(
  mapStateToProps,
  { getS3FilebrowserDirectory, getS3Tokens, fetchVideoTemplateByName }
)(VideoTemplatesForm);
